var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Regular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 8.25C5.74264 8.25 6.75 7.24264 6.75 6C6.75 4.75736 5.74264 3.75 4.5 3.75C3.25736 3.75 2.25 4.75736 2.25 6C2.25 7.24264 3.25736 8.25 4.5 8.25Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M4.5 9.75C2.42893 9.75 0.75 11.4289 0.75 13.5V15.75H2.25L3 21.75H6",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 8.25C20.7426 8.25 21.75 7.24264 21.75 6C21.75 4.75736 20.7426 3.75 19.5 3.75C18.2574 3.75 17.25 4.75736 17.25 6C17.25 7.24264 18.2574 8.25 19.5 8.25Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M19.5 9.75C21.5711 9.75 23.25 11.4289 23.25 13.5V15.75H21.75L21 21.75H18",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.75C13.6569 6.75 15 5.40685 15 3.75C15 2.09315 13.6569 0.75 12 0.75C10.3431 0.75 9 2.09315 9 3.75C9 5.40685 10.3431 6.75 12 6.75Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 13.5C17.25 10.6005 14.8995 8.25 12 8.25C9.10051 8.25 6.75 10.6005 6.75 13.5V15.75H9L9.75 23.25H14.25L15 15.75H17.25V13.5Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleUsersIcon);
export default __webpack_public_path__ + "static/media/multipleUsersIcon.d1cec338791d6f96845cc052d9e5f8d0.svg";
export { ForwardRef as ReactComponent };